import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { IconArrowRise } from "@/components/landing/icons";

/**
 * The hero’s primary action: paste, don’t sign up.
 *
 * Marketplace-pattern thinking — the search field IS the call to action, and
 * every step between arriving and getting value is a step people drop at. So
 * the field lives in the hero and carries the paste straight into the free
 * scan rather than asking for an account first.
 *
 * The text is handed over in session storage rather than a query string: a
 * resume in a URL ends up in browser history, server logs and any analytics
 * that records paths.
 */
export default function HeroScanField({ dark = false }) {
  const navigate = useNavigate();
  const [text, setText] = useState("");

  const go = (e) => {
    e.preventDefault();
    if (text.trim()) {
      try { sessionStorage.setItem("nextopp_scan_resume", text); } catch { /* ignore */ }
    }
    navigate("/ats-resume-checker");
  };

  return (
    <form onSubmit={go} className="mt-8" data-testid="hero-scan-form">
      <label htmlFor="hero-resume" className="sr-only">
        Paste your resume to scan it
      </label>
      <div className="flex flex-col sm:flex-row gap-2">
        <textarea
          id="hero-resume"
          rows={1}
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder="Paste your resume here — no account needed"
          data-testid="hero-resume-input"
          className={`flex-1 min-h-[56px] px-4 py-4 text-[15px] rounded-sm outline-none resize-none transition-colors ${dark ? "bg-white/[0.05] border border-white/15 text-white placeholder:text-white/55 focus:border-dawn-300/70 focus:ring-2 focus:ring-dawn-500/20" : "bg-white border border-sand focus:border-brand focus:ring-2 focus:ring-brand/20 placeholder:text-stone-600"}`}
        />
        <button
          type="submit"
          data-testid="hero-primary-cta"
          className={`h-[56px] px-7 shrink-0 rounded-sm font-medium inline-flex items-center justify-center gap-2 transition-all ${dark ? "bg-dawn-500 text-night hover:bg-dawn-300 shadow-[0_0_0_0_rgba(255,143,94,0)] hover:shadow-[0_8px_30px_-6px_rgba(255,143,94,0.45)]" : "bg-brand hover:bg-brand-hover text-white"}`}
        >
          Scan it free <IconArrowRise className="w-4 h-4" />
        </button>
      </div>
      <p className={`mt-2.5 text-xs ${dark ? "text-white/55" : "text-stone-600"}`}>
        We score it against any job in seconds. Nothing is stored until you make an account.
      </p>
    </form>
  );
}
